import React, { useEffect, useRef, useState } from 'react'
import F2 from '@antv/f2';
import { isIosOrA } from '@/utils/utils'
import './index.scss'


const Annular = ({ targetNum, finishNum, percent, canvasSize }) => {
    let dataCount = parseInt(100 / (targetNum / finishNum));
    // console.log(dataCount,'wangshuai')
    // 控制cavans精度
    const dprchange = () => {
        let dpr = window.devicePixelRatio;
        if (isIosOrA()) {
            return 5
        } else {
            return dpr >= 2 ? 10 : 5
        }

    }

    // 控制文本大小
    const fontchange = () => {
        if (isIosOrA()) {
            return 12
        } else {
            return 24
        }
    }
    // chart实例 
    let [mychart, setMyChart] = useState(null);

    let dom = useRef()
    useEffect(() => {
        const chart = new F2.Chart({
            id: dom.current,
            pixelRatio: window.devicePixelRatio
        });
        
        setMyChart(chart);
    }, [])
    useEffect(() => {
        if (mychart) {
            const data = [{
                x: '1',
                y: dataCount >= 100 ? 100 : dataCount
            }];
            mychart.source(data, {
                y: {
                    max: 100,
                    min: 0
                }
            });
            mychart.axis(false);
            mychart.tooltip(false);
            mychart.coord('polar', {
                transposed: true,
                innerRadius: 0.8,
                radius: .85
            });
            mychart.guide().arc({
                start: [0, 0],
                end: [0, 99.99],
                top: false,
                style: {
                    lineWidth: dprchange(),
                    stroke: '#dfe3f0'
                }
            });
            mychart.guide().text({
                position: ['50%', '50%'],
                content: `${percent}%`,
                style: {
                    fill: '#0450D9',
                    fontSize: fontchange()
                }
            });
            mychart.interval()
                .position('x*y')
                .color('#0450D9')
                .size(dprchange())
                .animate({
                    appear: {
                        duration: 1200,
                        easing: 'cubicIn'
                    }
                });
            mychart.render();
        }
        return () => {
            if(!mychart) return;
            mychart.clear()
        }
    }, [targetNum, finishNum, percent])
    return (
        <div className="annular__box">
            <canvas ref={dom} style={{ width: canvasSize, height: canvasSize }}></canvas>
        </div>
    )
}
export default Annular
